import React from 'react';
import { Paper, BottomNavigation as MuiBottomNavigation, BottomNavigationAction, Box, useTheme, useMediaQuery } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { colors } from '../../theme/themeConfig';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import CasinoOutlinedIcon from '@mui/icons-material/CasinoOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import CardGiftcardOutlinedIcon from '@mui/icons-material/CardGiftcardOutlined';
import AttractionsOutlinedIcon from '@mui/icons-material/AttractionsOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';

interface NavItem {
  path: string;
  icon: React.ReactNode;
  label: string;
}

const BottomNavigationComponent: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const navItems: NavItem[] = [
    { 
      path: '/', 
      icon: <StorefrontOutlinedIcon sx={{ color: location.pathname === '/' ? colors.primary.main : 'inherit' }} />, 
      label: 'Главная' 
    },
    // { 
    //   path: '/shop', 
    //   icon: <StorefrontOutlinedIcon sx={{ color: location.pathname === '/shop' ? colors.primary.main : 'inherit' }} />, 
    //   label: 'Магазин' 
    // },
    {
      path: '/popularity',
      icon: <TrendingUpOutlinedIcon sx={{ color: location.pathname === '/popularity' ? colors.primary.main : 'inherit' }} />,
      label: 'Популярность'
    },
    {
      path: '/bonus',
      icon: <StarBorderOutlinedIcon sx={{ color: location.pathname === '/bonus' ? colors.primary.main : 'inherit' }} />,
      label: 'Бонусы'
    },
    {
      path: '/orders/history',
      icon: <ReceiptLongOutlinedIcon sx={{ color: location.pathname.startsWith('/orders') ? colors.primary.main : 'inherit' }} />,
      label: 'Заказы'
    },
    { 
      path: '/referral', 
      icon: <PeopleAltOutlinedIcon sx={{ color: location.pathname === '/referral' ? colors.primary.main : 'inherit' }} />, 
      label: 'Рефералы' 
    },
    { 
      path: '/spin', 
      icon: <AttractionsOutlinedIcon sx={{ color: location.pathname === '/spin' ? colors.primary.main : 'inherit' }} />, 
      label: 'Вращение' 
    },
  ];
  
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: '16px',
        left: '16px',
        right: '16px',
        zIndex: 100,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          backgroundColor: '#2A2A2A',
          borderRadius: '16px',
          overflow: 'hidden',
          height: '64px',
        }}
      >
        <MuiBottomNavigation
          value={location.pathname}
          onChange={(event, newValue) => {
            navigate(newValue);
          }}
          sx={{
            backgroundColor: 'transparent',
            height: '100%',
          }}
        >
          {navItems.map((item) => (
            <BottomNavigationAction
              key={item.path}
              value={item.path}
              icon={item.icon}
              sx={{
                color: location.pathname === item.path ? colors.primary.main : colors.text.primary,
                minWidth: 'auto',
                padding: 0,
                '&.Mui-selected': {
                  color: colors.primary.main,
                },
                '&:hover': {
                  color: location.pathname === item.path ? colors.primary.main : colors.text.secondary,
                },
              }}
            />
          ))}
        </MuiBottomNavigation>
      </Paper>
    </Box>
  );
};

export default BottomNavigationComponent;
